import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {Filters} from "./model/filters";
import {BaseFilters} from "./class/BaseFilters";

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
  @Input() filters: Array<BaseFilters> = [];
  @Output() onFilterChange = new EventEmitter();
  @Input() defaultValues;
  dateOperators = [{
    label: '<=',
    value: '<='
  },
    {
      label: '>=',
      value: '>='
    },
    {
      label: '=',
      value: '='
    }];

  calendarLocal: any = {};

  yearRange: string = (new Date().getFullYear() - 80) + ':' + (new Date().getFullYear() + 80);

  search(filter?) {

    let triggerChange = true;
    if (filter && filter['dateFilterOperator']) {

      if (filter["operator"] == "<=") {
        if (typeof filter["value"] == "object") {
          filter["value"].setHours(0);
          filter["value"].setMinutes(0);
        }
      }
    }
    if (filter && filter["fdef"] && (filter["fdef"]["fieldtype"] == "href" || filter["fdef"]["fieldtype"] == "objects")) {

      if (filter["object"] && filter["object"]["id"] == filter["value"]) {
        triggerChange = false;
      }
      if (filter["object"] && filter["object"]["id"]) {
        filter["value"] = filter["object"]["id"];
      } else {
        filter["value"] = null;
      }


    }
    if (triggerChange) {
      this.onFilterChange.emit();
    }

  }

  changeDateOperator(filter) {
    if (filter["operator"] == "=") {
      filter["selectedMode"] = "range";
    } else {
      filter["selectedMode"] = "single";
    }
    filter["value"] = "";
  }

  resetFilter() {
    for (let i in this.filters) {
      this.filters[i]['value'] = '';
      this.filters[i]['object'] = {};
    }
    this.onFilterChange.emit();
  }

  ngOnInit() {
    for (let i in this.filters) {
      if (this.defaultValues) {
        let f = this.filters[i];
        if (typeof this.defaultValues[f["field"]] != "undefined") {
          this.filters[i]["value"] = this.defaultValues[f["field"]];
        }
      }
      if (this.filters[i] && !this.filters[i]["fdef"]) {
        this.filters[i]["fdef"] = []
      }

      let minDate = this.filters[i]["minDate"];
      var todaysDate = new Date();
      if (minDate != undefined) {
        if (minDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
          // Date equals today's date
          this.filters[i]["minDate"] = new Date();
        } else {
          this.filters[i]["minDate"] = minDate;
        }
      }
      if (this.filters[i]['dateFilterOperator']) {
        if (this.filters[i]['operator'] && this.filters[i]['operator'] == "=") {
          this.filters[i]["selectedMode"] = "range";
        } else {
          this.filters[i]["selectedMode"] = "single";
        }
        if (!this.filters[i]['operator']) {
          this.filters[i]["operator"] = this.dateOperators[0]['value'];
        }

      } else {
        this.filters[i]["selectedMode"] = "range";
      }

      if (this.filters[i] && this.filters[i]["fdef"] && this.filters[i]["fdef"]["fieldtype"] == "href") {
        if (this.filters[i]["field"].indexOf("__id") < 0) {
          this.filters[i]["field"] += "__id";
        }
      }
      if (this.filters[i] && this.filters[i]["fdef"] && this.filters[i]["fdef"]["fieldtype"] == "objects") {
        this.filters[i]["operator"] = "LIKE";
      }

      if (!this.filters[i]["value"]) {
        this.filters[i]["value"] = '';
      }

      if (!this.filters[i]["object"]) {
        this.filters[i]["object"] = {};
      }

      if (this.filters[i] && !this.filters[i]["fdef"]["fieldtype"]) {
        this.filters[i]["fdef"]["fieldtype"] = "default"
      }

    }

    this.calendarLocal = {
      firstDayOfWeek: 1,
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
      monthNames: ["Janvier", "Fevrier", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Decembre"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jui", "Jui", "Aou", "Sep", "Oct", "Nov", "Dec"],
      today: "Aujourd'hui",
      clear: 'Reset'
    };


  }

}
